import { useOrganizationContext } from "../api/current-organization/organizationContext";
import { useTalentGigInvites } from "../api/talentGigInvites";
import Card from "../components/Card";
import LinkButton from "../components/LinkButton";
import Loader from "../components/Loader";
import PageContent from "../components/PageContent";
import PaginationControls from "../components/PaginationControls";
import Typography from "../components/Typography";
import { useIsLargeScreen } from "../hooks/screenSizes";
import { gigInviteStatuses } from "../models/app/gigInvite";
import { useAppPaths } from "../Routes";

const GigInvitesPage = () => {
    const appPaths = useAppPaths();
    const {
        gigInvites,
        isLoading,
        pageIndex,
        pageSize,
        totalCount,
        totalPages,
        hasPreviousPage,
        hasNextPage,
        setPageIndex,
    } = useTalentGigInvites(gigInviteStatuses.sent);
    const isLargeScreen = useIsLargeScreen();

    const { gigTerminology } = useOrganizationContext();

    if (isLoading) return <Loader />;

    const paginationProps = {
        pageIndex,
        setPageIndex,
        pageSize,
        totalCount,
        totalPages,
        hasPreviousPage,
        hasNextPage,
        itemName: "invites"
    };

    return (
        <PageContent>
            <Typography variant={isLargeScreen ? "display-large" : "display-small"} component="h1" gutterBottom>{gigTerminology} Invites</Typography>
            {gigInvites.length === 0 ? (
                <Card>
                    <Typography variant="title-large" component="p">No pending invites</Typography>
                </Card>
            ) : (
                <>
                    {/* Top pagination controls */}
                    <PaginationControls
                        {...paginationProps}
                        className="mb-6"
                    />
                    <div className="space-y-8">
                        {gigInvites.map(gigInvite => (
                            <Card key={gigInvite.gigId} className="flex flex-col md:flex-row text-center md:text-left items-center grow md:mr-4 rounded-b-none md:rounded-b-lg pb-2 md:pb-6">
                                <div className="md:mr-8 space-y-2">
                                    <Typography variant="title-large" component="p" className="mb-4">{gigInvite.gigTitle}</Typography>
                                    <div>
                                        <span className="font-bold">Date received: </span>
                                        {gigInvite.dateSent.toLocaleDateString()}
                                    </div>
                                    <div className="md:mr-8">
                                        <span className="font-bold">Message: </span>
                                        <span className="italic whitespace-pre-wrap">{gigInvite.message}</span>
                                    </div>
                                    <div className="w-fit rounded-full px-4 py-1.5 font-bold text-white mt-4 bg-[#9e9e9e]">
                                        Pending
                                    </div>
                                </div>
                                <LinkButton className="block md:ml-auto" to={appPaths.gigs.findAGigDetails(gigInvite.gigId)} variant="tertiary">View {gigTerminology}</LinkButton>
                            </Card>
                        ))}
                    </div>
                    {/* Bottom pagination controls */}
                    <PaginationControls
                        {...paginationProps}
                        className="mt-8"
                    />
                </>
            )
            }
        </PageContent>
    );
};

export default GigInvitesPage;